export const PostType = {
    blog: 'blog',
    press: 'press',
    event: 'event'
}